<template>
  <span class="inline-flex">
    <img
      src="/logo_short_transparent.png"
      alt="mychar logo"
      class="mark-light size-full object-contain"
    >
    <img
      src="/logo_short_transparent_white.png"
      alt="mychar logo"
      class="mark-dark size-full object-contain"
    >
  </span>
</template>

<style scoped>
.mark-dark {
  display: none;
}

.dark .mark-dark {
  display: block;
}

.dark .mark-light {
  display: none;
}
</style>
